<template>
  <div></div>
</template>

<script>
import { getPreOrderLinkByShortCode } from "@/api/reservation";
import logger from "@/utils/logger";

const name = "PreOrderRedirect";
const log = logger(name);

export default {
  name,
  async created() {
    if (this.$route.params.shortCode) {
      log.info(
        `Redirecting reservation ${this.$route.params.shortCode} to pre-order`
      );
      const redirectUrl = await getPreOrderLinkByShortCode(
        this.$route.params.shortCode
      );
      log.info(`Redirect link ${redirectUrl}`);
      window.location.href = redirectUrl;
      return;
    }
    log.info("No reservation short code found");
    this.$router.replace("/");
  },
};
</script>

<style scoped></style>
